import { Tooltip } from '@radix-ui/themes';
import CountUp from 'react-countup';

import styles from './StatCard.module.css';

export const StatCard = ({
  title,
  value,
  icon,
  tooltip,
  description,
  suffix = '',
  trend,
  loading = false,
}) => {
  const getTrendClass = () => {
    if (!trend) return null;
    if (trend > 0) return styles.trendUp;
    if (trend < 0) return styles.trendDown;
    return styles.trendNeutral;
  };

  const formatTrend = () => {
    if (trend === undefined || trend === null) return null;
    const sign = trend > 0 ? '+' : '';
    return `${sign}${trend}%`;
  };

  const card = (
    <div className={styles.card}>
      <div className={styles.header}>
        <div className={styles.labelGroup}>
          {icon && <i className={`${icon} ${styles.icon}`} />}
          <p className={styles.label}>{title}</p>
        </div>
        {trend !== undefined && trend !== null && (
          <span className={`${styles.trend} ${getTrendClass()}`}>
            {trend > 0 && <i className="fa-solid fa-arrow-up" />}
            {trend < 0 && <i className="fa-solid fa-arrow-down" />}
            {formatTrend()}
          </span>
        )}
      </div>
      <p className={styles.value}>
        {loading ? (
          <i className={`fa-solid fa-spinner fa-spin ${styles.spinner}`} />
        ) : (
          <>
            <CountUp end={value} duration={0.8} separator="," preserveValue />
            {suffix}
          </>
        )}
      </p>
      {description && <p className={styles.description}>{description}</p>}
    </div>
  );

  if (tooltip) {
    return <Tooltip content={tooltip}>{card}</Tooltip>;
  }

  return card;
};
